import { render, staticRenderFns } from "./ticketsSupportList.vue?vue&type=template&id=3fda4b7a&scoped=true"
import script from "./ticketsSupportList.vue?vue&type=script&lang=js"
export * from "./ticketsSupportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fda4b7a",
  null
  
)

export default component.exports